import { combineReducers } from '@ngrx/store';

export const userAlertsRootReducer = combineReducers({});

